/// <amd-module name="Repos/Common/ReposShortcutsService" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { GitRepository } from "./Contracts/Git";
import { getReposRoutingService, IReposRoutingService } from "./ReposRoutingService";
import { getGitRepository } from "./VCViewModelDataProviderService";

export interface IReposShortcutsService extends IVssService {
    gotoBranches(): void;
    gotoCommits(): void;
    gotoCreatePullRequest(): void;
    gotoFiles(): void;
    gotoPullRequests(): void;
}

class ReposShortcutsService extends VssService implements IReposShortcutsService {
    private repository: GitRepository;
    private routingService: IReposRoutingService;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        this.repository = getGitRepository(pageContext)!;
        this.routingService = getReposRoutingService(this.pageContext);
    }

    public gotoBranches(): void {
        const url = this.routingService.getBranchesUrl(this.repository.name, this.repository.project.name);
        FastPageSwitch(this.pageContext, url, true);
    }

    public gotoCommits(): void {
        const url = this.routingService.getCommitsUrl(this.repository.name, this.repository.project.name);
        FastPageSwitch(this.pageContext, url, true);
    }

    public gotoCreatePullRequest(): void {
        const url = this.routingService.getPullRequestCreateUrl(this.repository.name, this.repository.project.name);
        FastPageSwitch(this.pageContext, url, true);
    }

    public gotoFiles(): void {
        const url = this.routingService.getFilesUrl(this.repository.name, this.repository.project.name);
        FastPageSwitch(this.pageContext, url, true);
    }

    public gotoPullRequests(): void {
        const url = this.routingService.getPullRequestsUrl();
        FastPageSwitch(this.pageContext, url, true);
    }
}

Services.add("IReposShortcutsService", { serviceFactory: ReposShortcutsService });
